import { ResourceFilters } from '../../types/ResourceFilters';
import { Resource } from '../../types/Resource';
import { ACCESS_ANALYSIS_BASE_URL } from '../consts';
import { useFetchWithOffsetPagination } from '../base/useFetchWithOffsetPagination';

const mapResponse = (resource: Resource): Resource => ({
    ...resource,
    name: resource.name ?? resource.resource_id,
    last_access: resource.last_access ? new Date(resource.last_access) : undefined
});

export const useGetResources = (filters: ResourceFilters, sorting: { direction: 'asc' | 'desc'; field: string }) => {
    const { data, fetchNextPage, loading, refresh } = useFetchWithOffsetPagination<Resource, Resource, ResourceFilters>(
        {
            url: `${ACCESS_ANALYSIS_BASE_URL}/resources`,
            filters,
            sorting,
            mapResponse
        }
    );

    return {
        resources: data,
        resourcesLoading: loading,
        fetchMoreResources: fetchNextPage,
        refetchResources: refresh
    };
};
